<!-- START Main Passenger Information form -->

<app-notification *ngIf="error" [style]="'alert'" [icon]="'icons.svg#airport--delays'" 
	[title]="error | ibeadmin | async ">
	<div message>
		<span>
			{{ 'bookingDetails.error.milesAndGoInfoMismatch' | ibeadmin:'sync' }}
		</span>
	</div>
</app-notification>


<form class="sidebar__form" [formGroup]="form">
	<div class="form--edit-mode">
		<div class="form-field--row grid no-padding">
			
			<div class="form-field col-2 col-tp-2 col-p-12" *ngIf="!isInfant && !isChild">
				<label class="label" for="main-info--contact_title">
					{{ 'bookingDetails.label.paxTitle' | ibeadmin:'sync' }}
				</label>
				<app-select-input-indra
					selectId="selectTitle"
					formControlName="title" 
					id="main-info--contact_title"
					[placeholder]="'bookingDetails.text.choose' | ibeadmin:'sync'"
					[options]="titleOptions">
				</app-select-input-indra>
				<span 
					aria-live="polite" 
					class="input-error" 
					role="alert"
					[attr.aria-label]="formMainInfoErrors('title')"
					*ngIf="form.controls['title'].invalid && isMobile && displayValidationMessages">
					{{ formMainInfoErrors('title') | ibeadmin:'sync' }}
				</span>
			</div>
			
			<div class="form-field col-5 col-tp-5 col-p-12">
				<label class="label" for="main-info--contact_firstName">
					{{ 'bookingDetails.label.firstName' | ibeadmin:'sync' }}
				</label>
				<input 
					class="input-text"
					formControlName="name" 
					id="main-info--contact_firstName" 
					maxlength="25"/>
				<!--
				<span 
					aria-live="polite" 
					class="input-error" 
					role="alert"
					[attr.aria-label]="formMainInfoErrors('name')"
					*ngIf="form.controls['name'].invalid && isMobile && displayValidationMessages">
					{{ formMainInfoErrors('name') | ibeadmin:'sync' }}
				</span>
				-->
			</div>
			
			<div class="form-field col-5 col-tp-5 col-p-12">
				<label class="label" for="main-info--contact_lastName">
					{{ 'bookingDetails.label.lastName' | ibeadmin:'sync' }}
				</label>
				<input 
					class="input-text"
					formControlName="surname" 
					id="main-info--contact_lastName" 
					maxlength="25"/>
				<span 
					aria-live="polite" 
					class="input-error" 
					role="alert"
					[attr.aria-label]="formMainInfoErrors('name')"
					*ngIf="(form.controls['name'].invalid || form.controls['surname'].invalid) && isMobile && displayValidationMessages">
					{{ formMainInfoErrors('name') | ibeadmin:'sync' }}
				</span>
				<br>
				<span 
					aria-live="polite" 
					class="input-error" 
					role="alert"
					[attr.aria-label]="formMainInfoErrors('maxNameCharReached') | ibeadmin:'sync'"
					*ngIf="form.hasError('maxNameCharReached') && displayValidationMessages && isMobile">
					{{ formMainInfoErrors('maxNameCharReached') | ibeadmin:'sync'  }}
				</span>
			</div>
			
			<ng-container *ngIf="!isMobile">
				<div class="form-field form-field--no-top col-2 col-tp-2 col-p-12">
					<span 
						aria-live="polite" 
						class="input-error" 
						role="alert"
						*ngIf="form.controls['title'].invalid && displayValidationMessages">
						{{ formMainInfoErrors('title') | ibeadmin:'sync' }}
					</span>
				</div>
				<div class="form-field form-field--no-top col-5 col-tp-5 col-p-12">
					<span 
						aria-live="polite" 
						class="input-error" 
						role="alert"
						*ngIf="form.controls['name'].invalid && displayValidationMessages">
						{{ formMainInfoErrors('name') | ibeadmin:'sync' }}
					</span>
				</div>
				<div class="form-field form-field--no-top col-5 col-tp-5 col-p-12">
					<span 
						aria-live="polite" 
						class="input-error" 
						role="alert"
						*ngIf="form.controls['surname'].invalid && displayValidationMessages">
						{{ formMainInfoErrors('surname') | ibeadmin:'sync' }}
					</span>
				</div>
				<ng-container *ngIf="form.hasError('maxNameCharReached') && displayValidationMessages">
					<div class="form-field form-field--no-top col-2 col-tp-2 col-p-12"></div>
					<div class="form-field form-field--no-top col-10 col-tp-10 col-p-12">
						<span
							aria-live="polite"
							class="input-error"
							role="alert">
							{{ formMainInfoErrors('maxNameCharReached') | ibeadmin:'sync'  }}
						</span>
					</div>
				</ng-container>
			</ng-container>
			<input 
				type="hidden"
				formControlName="isNew" 
				id="main-info--contact_isNew" 
				maxlength="25"
				value="true"/>
		</div>
		
		<p class="muted bottom-gap">
			{{ 'bookingDetails.text.enterFirstLastName' | ibeadmin:'sync' }}
		</p>
		
		<div class="form--edit-mode">
			<div class="form-field--row grid no-padding" *ngIf="isInfant || isChild || isYoungAdult || showAdditionalFields">
				<div class="form-field col-5 col-tp-12 col-p-12">
					<app-select-input-indra
						selectId="selectGender"
						label="{{'bookingDetails.label.gender' | ibeadmin:'sync'}}"
						placeholder="{{'bookingDetails.label.selectGender' | ibeadmin:'sync'}}"
						formControlName="gender"
						id="main-info--gender"
						[options]="genderCodes"
						selectLabel="{{'bookingDetails.label.selectGender' | ibeadmin:'sync'}}"
					>
					</app-select-input-indra>
					<span
							aria-live="polite"
							class="input-error"
							role="alert"
							[attr.aria-label]="formMainInfoErrors('gender') | ibeadmin:'sync'"
							*ngIf="form.controls['gender'].invalid && displayValidationMessages"
						>
						{{ formMainInfoErrors('gender') | ibeadmin:'sync'}}
					</span>
				</div>
				<div class="form-field no-margin col-6 col-tp-12 col-p-12">
					<app-date-form-indra
						uniqueId="dob"
						label="{{'bookingDetails.label.dateOfBirth' | ibeadmin:'sync'}}"
						dayLabel="{{'bookingDetails.label.dayOfBirth' | ibeadmin:'sync'}}"
						monthLabel="{{'bookingDetails.label.monthOfBirth' | ibeadmin:'sync'}}"
						yearLabel="{{'bookingDetails.label.yearOfBirth' | ibeadmin:'sync'}}"
						formControlName="birthDate"
						[onlyPast]="true"
						[paxType]="passengerInfo.typePax"
						[departureDate]="departureDate"
					>
					</app-date-form-indra>
					<span
						aria-live="polite"
						class="input-error"
						role="alert"
						[attr.aria-label]="formMainInfoErrors('birthDate') | ibeadmin:'sync'"
						*ngIf="form.controls['birthDate'].invalid && displayValidationMessages"
					>
						{{ formMainInfoErrors('birthDate') | ibeadmin:'sync'}}
					</span>
				</div>
			</div>
		</div>
		<hr class="separator">
	</div>
</form>
	
<!-- END Main Passenger Information form -->
	
